<div cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <div class="head" [ngClass]="selectedOption?.class" [class.simple-view]="dataFilterConfig?.simpleView" *ngIf="!isSiteDropdown">
        <input
            type="text"
            name="filter"
            readonly
            #inputControl
            [ngClass]="{ 'opened': isOpened }"
            [(ngModel)]="valueText"
            [disabled]="isDisabled"
            [placeholder]="placeholderText"
            (focus)="onFocus(); inputFocused.emit(true)"
            (blur)="inputFocused.emit(false)"
            (click)="toggleState()">

        <button type="button" class="value-text"
            *ngIf="dataFilterConfig?.simpleView"
            (click)="toggleState()"
            style="border:none;background:transparent;font:inherit;color:inherit;text-align:left;"> {{ valueText }}
            <i class="icon-ic_expand_arrow" [class.inverted]="isOpened"></i>
        </button>
    </div>

    <button type="button" *ngIf="isSiteDropdown"
        (click)="toggleState()"
        class="sites-dropdown-header"
        [class.active]="this.isOpened"
        style="border:none;background:transparent;padding:0;display:block;width:100%;font:inherit;color:inherit;"
        #inputControl>
        <span>{{ placeholderText }}: </span> {{ showDropdownTitle() }}
        <i class="icon-ic_dropdown_arrow"></i>
    </button>
</div>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpened"
    [cdkConnectedOverlayWidth]="optionsWidth"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
>
    <div class="options-list"
        [class.filter-mode]="dataFilterConfig"
        [class.multi]="dataFilterConfig?.type === 'multi'">
        <ng-container *ngIf="!dataFilterConfig; else templateWithFilter" >
            <!-- options list -->
            <ul role="listbox">
                <li *ngIf="allowResetControl">
                    <div class="option"
                        (click)="optionOnClick({ keyName: null })"
                        (keydown.enter)="optionOnClick({ keyName: null })"
                        tabindex="0"
                        role="option"
                        [attr.aria-selected]="!selectedOption">
                        Not selected
                    </div>
                </li>
                <li *ngFor="let option of optionsList; let ind = index;">
                    <div appEllipsisTooltip
                        (click)="optionOnClick(option)"
                        (keydown.enter)="optionOnClick(option)"
                        tabindex="0"
                        role="option"
                        [attr.aria-selected]="option.selected"
                        [ngClass]="{
                            'disabled': option.disabled,
                            'selected': option.selected
                        }"
                        class="option {{option.class}}">
                        {{ option[dropdownValueName || valueName] }}
                    </div>
                </li>
            </ul>

            <!-- no data message -->
            <div *ngIf="!optionsList.length" class="no-data-msg">{{ noDataText }}</div>
        </ng-container>
    </div>
</ng-template>

<ng-template #templateWithFilter>
    <ng-container [ngSwitch]="dataFilterConfig.type">
        <ng-template ngSwitchCase="simple">
            <ng-container *ngTemplateOutlet="templateSimple"></ng-container>
        </ng-template>
    </ng-container>
</ng-template>

<ng-template #templateSimple>
    <div class="dropdown-search" *ngIf="optionsList.length > dropdownConfig?.filterLimit">
        <input [(ngModel)]="filterQuery"
               type="search" [placeholder]="dataFilterConfig.placeholder || 'Search'"
               (focus)="$event.stopPropagation()"
               (click)="$event.stopPropagation()">
        <i class="icon-search search-icon"></i>
        <button type="button" *ngIf="filterQuery" class="icon-cross_16px clear-control" (click)="$event.stopPropagation(); filterQuery=''" style="font:inherit;color:inherit;"></button>
    </div>

    <!-- options list -->
    <ul role="listbox" *ngIf="optionsList && (optionsList | filterBy: filterQuery: dataFilterConfig.filterField: dataFilterConfig.strictFiltering).length;
        else noFilteredResults">
        <li *ngIf="allowResetControl">
            <div class="option"
                (click)="optionOnClick({ keyName: null })"
                (keydown.enter)="optionOnClick({ keyName: null })"
                tabindex="0"
                role="option"
                [attr.aria-selected]="!selectedOption">
                Not selected
            </div>
        </li>
        <li *ngFor="let option of optionsList | filterBy: filterQuery: dataFilterConfig.filterField: dataFilterConfig.strictFiltering;
            let ind = index;">
            <div appEllipsisTooltip
                (click)="optionOnClick(option); filterQuery=''"
                (keydown.enter)="optionOnClick(option); filterQuery=''"
                tabindex="0"
                role="option"
                [attr.aria-selected]="option.selected"
                [ngClass]="{
                    'disabled': option.disabled,
                    'selected': option.selected
                }"
                class="option {{option.class}}"
                [id]="option[keyName]"
                [innerHTML]="option[dropdownValueName || valueName]
                    | htmltransfrom | highlight: filterQuery : dataFilterConfig.minHighlightLength">
            </div>
        </li>
    </ul>
</ng-template>

<ng-template #noFilteredResults>
    <div class="no-data-msg">{{ dataFilterConfig.noDataText }}</div>
</ng-template>
